import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent, Typography } from '@mui/material';
export default function StatTile({ label, value, valueVariant = 'h5', valueColor, caption }) {
    return (_jsx(Card, { elevation: 2, children: _jsxs(CardContent, { children: [_jsx(Typography, { variant: "subtitle2", color: "text.secondary", children: label }), _jsx(Typography, { variant: valueVariant, sx: {
                        color: valueColor,
                        ...(valueVariant === 'h3' && { lineHeight: 1 }),
                    }, children: value }), caption != null && (_jsx(Typography, { variant: "caption", color: "text.secondary", children: caption }))] }) }));
}
